import { Popover } from 'element-ui';
import PopoverMixin from './Popover';
export default {
  components: {
    Popover: Popover
  },
  mixins: [PopoverMixin],
  props: {
    disabled: Boolean,
    popperClass: {
      type: String,
      default: 'my-base-picker__popover'
    },
    refClass: String
  }
};